<template>
  <div>
    <configurar-associacao-fila-tipo-solicitacao-dialog
      :is-configurar-associacao-fila-tipo-solicitacao-dialog-open.sync="isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen"
      :fila-id="filaId"
      @refetch-data="getTiposDeSolicitacaoAssociados"
    />

    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card
      flat
      class="pa-3 mt-2"
    >
      <fila-sla-primeira-resposta-card :fila-id="filaId" />

      <v-card class="d-flex justify-space-between">
        <v-card-title>Tipos de Solicitação</v-card-title>
        <v-btn
          v-if="!acessoPost"
          color="primary"
          class=" ma-3"
          disabled
        >
          <span>Adicionar</span>
        </v-btn>

        <v-btn
          v-else
          color="primary"
          class=" ma-3"
          @click="isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen = !isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen"
        >
          <span>Adicionar</span>
        </v-btn>
      </v-card>

      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </div>

      <table-associacao-fila-tipo-solicitacao
        :items="tiposDeSolicitacao"
        :acesso-disable="acessoDisable"
        :fila-id="filaId"
        @refetch-data="getTiposDeSolicitacaoAssociados"
      />
    </v-card>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import ConfigurarAssociacaoFilaTipoSolicitacaoDialog from './ConfigurarAssociacaoFilaTipoSolicitacaoDialog.vue'
import TableAssociacaoFilaTipoSolicitacao from './TableAssociacaoFilaTipoSolicitacao.vue'
import FilaSlaPrimeiraRespostaCard from './FilaSlaPrimeiraRespostaCard.vue'
import Contadores from '@/components/contadores/Contadores.vue'
import router from '@/router'
import useAuthStore from '@/store/auth'
import FilaService from '@/services/modules/FilaService'

export default {
  components: {
    ConfigurarAssociacaoFilaTipoSolicitacaoDialog,
    TableAssociacaoFilaTipoSolicitacao,
    FilaSlaPrimeiraRespostaCard,
    Contadores,
  },

  setup() {
    const filaId = Number(router.currentRoute.params.id)
    const isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen = ref(false)

    const { funcionalidades } = storeToRefs(useAuthStore())

    const idPost = 2015
    const idDisable = 2016
    const acessoPost = ref(true)
    const acessoDisable = ref(true)

    function permissoes() {
      if (!funcionalidades.value.includes(idPost)) {
        acessoPost.value = false
      }
      if (!funcionalidades.value.includes(idDisable)) {
        acessoDisable.value = false
      }
    }
    onMounted(permissoes)

    const tiposDeSolicitacaoTodos = ref([])
    const tiposDeSolicitacao = ref([])
    const filtroStatus = ref('true')
    const contadores = ref({ total: 0, ativos: 0, inativos: 0 })
    const loading = ref(false)

    function aplicarFiltro() {
      contadores.value.total = tiposDeSolicitacaoTodos.value.length
      contadores.value.ativos = tiposDeSolicitacaoTodos.value.filter(it => it.ativo).length
      contadores.value.inativos = tiposDeSolicitacaoTodos.value.filter(it => !it.ativo).length

      tiposDeSolicitacao.value = filtroStatus.value
        ? tiposDeSolicitacaoTodos.value.filter(it => it.ativo.toString() === filtroStatus.value)
        : tiposDeSolicitacaoTodos.value
    }

    async function getTiposDeSolicitacaoAssociados() {
      loading.value = true
      try {
        tiposDeSolicitacaoTodos.value = await FilaService.getTiposDeSolicitacoesAssociadosAUmaFila(filaId)
        aplicarFiltro()
      } finally {
        loading.value = false
      }
    }
    onMounted(getTiposDeSolicitacaoAssociados)

    function atualizarFiltro(item) {
      filtroStatus.value = item
      aplicarFiltro()
    }

    return {
      filaId,
      isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen,
      acessoPost,
      acessoDisable,
      tiposDeSolicitacao,
      contadores,
      atualizarFiltro,
      loading,
      getTiposDeSolicitacaoAssociados,
    }
  },
}
</script>
